import { register, createReduxStore } from '@wordpress/data';
import reducer from './reducer';
import * as actions from './actions';
import * as selectors from './selectors';
import { STORE_KEY } from './constants';
const store = createReduxStore(STORE_KEY, {
  actions,
  selectors,
  reducer
});
export default store;
register(store);
//# sourceMappingURL=index.js.map